import React from "react";
import defaultImg from "../images/defaultImg.png";
import { BiTime } from "react-icons/bi";
import { FaUtensils } from "react-icons/fa";
import { Link } from "react-router-dom";
export default function RecipeCard2({ recipe }) {
  const { id, image, title, readyInMinutes, servings, dishTypes } = recipe;

  return (
    <Link to={`/recipes/${id}`}>
      <article className="recipe">
        <div className="recipe-image-container">
          <img className="recipe-image" src={image || defaultImg} alt="" />
        </div>
        <h4 className="recipe-title">{title}</h4>
        <div className="recipe-details">
          <div className="svg-icon mr-5">
            <BiTime />
          </div>
          <p className="mr-10"> {readyInMinutes} min |</p>
          <p className="mr-10">
            {servings > 1 ? `${servings} servings` : `${servings} serving`} |
          </p>
          <div className="svg-icon mr-5">
            <FaUtensils />
          </div>
          <p>{dishTypes[0] || recipe.cuisines[0]}</p>
        </div>
      </article>
    </Link>
  );
}
